import {
  ACTIVATE_CARD_BEGIN,
  ACTIVATE_CARD_SUCCESS,
  ACTIVATE_CARD_FAILURE,
} from 'actions/activation';

const initialState = {
  success: false,
  error: false,
  loading: false,
};

export default function activation(state = initialState, action) {
  switch (action.type) {
    case ACTIVATE_CARD_BEGIN:
      return { ...initialState, loading: true };
    case ACTIVATE_CARD_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
      };
    case ACTIVATE_CARD_FAILURE:
      return { ...state, error: action.error, loading: false };
    default:
      return state;
  }
}
